<div
  class="member-join-container d-flex align-items-center m-0 flex-column"
  [ngClass]="{ mobile: innerWidth < 992 }"
>
  <div class="w-100 h-100">
    <div class="form-content d-flex flex-column">
      <div class="member-join-row">
        <canvas></canvas>

        <div class="flex-fill">
          <div class="pt-0">
            <div class="d-flex flex-fill content-steps step-1">
              <div class="w-50 member-join-bg d-flex flex-column flex-fill">
                <div class="member-join-bg-inner">
                  <a href="http://vervesuper.com.au/"
                    ><img
                      src="https://vervassets.blob.core.windows.net/web/Logo1.png"
                      class="member-join verv-logo"
                  /></a>
                  <div class="align-items-end flex-fill">
                    <img
                      src="https://vervassets.blob.core.windows.net/web/firstpage-people.webp"
                      *ngIf="innerWidth >= 800"
                      class="member-join-people d-flex"
                    />
                  </div>
                </div>
              </div>
              <div
                class="w-50 d-flex align-items-center content-margin"
                appanimatecss
              >
                <ng-container>
                  <div
                    id="login-container"
                    class="d-flex flex-row align-items-center"
                  >
                    <div
                      class="d-flex flex-row justify-content-center"
                      *ngIf="innerWidth >= 800"
                    >
                      <mat-progress-spinner
                        mode="indeterminate"
                        diameter="80"
                      ></mat-progress-spinner>
                    </div>
                    <div class="pl-4">
                      <h1 class="subheader">
                        Verve Super Join form is temporarily unavailable due to a significant event.
                      </h1>
                      <h3 class="mb-0">Please wait while we redirect you.</h3>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
